import React from 'react';
import { Reveal } from './ui/Reveal';
import { proofStats } from '../data/content';
export function SocialProof() {
  return <section aria-label="Todo lo que necesitás para comprender mejor la Biblia" className="border-b border-line bg-accent" data-id="element-238" data-mp="3ltm57xko2z6u">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-6" data-id="element-239" data-mp="36xy2kcuzyk52">
        <p className="text-center text-xs font-bold uppercase tracking-[0.24em] text-white/75" data-id="element-240" data-mp="3buwyn0y8115w">
          Todo lo que necesitás para comprender mejor la Biblia. En un solo
          lugar.
        </p>
        <dl className="mt-4 grid grid-cols-2 gap-x-6 gap-y-5 text-center md:grid-cols-4 md:divide-x md:divide-white/20" data-id="element-241" data-mp="8d6d4zei4kt8">
          {proofStats.map((stat, i) => <Reveal key={stat.label} delay={i * 0.03} className="md:px-6" data-id="element-242" data-mp="3usr6vcriz8n8" data-mpi={i}>
              <dt className="font-display text-3xl md:text-4xl font-bold text-white" data-id="element-243" data-mp="mdz97okgbnyg">
                {stat.value}
              </dt>
              <dd className="mt-1 text-sm font-semibold text-white/85" data-id="element-244" data-mp="r57kyr997les">
                {stat.label}
              </dd>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}